import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../../../context/AppContext';
import styles from './PageShell.module.scss';

/* ────────────────────────────────────────────────────────────
 * PageShell — outermost wrapper for every page in the app.
 *
 *   <PageShell>
 *     <PageHeader ... />
 *     <PagePanel> ... </PagePanel>
 *   </PageShell>
 *
 * Reads `sidebar` from AppContext to apply the global app-shell
 * `cx-active` modifier. This is the single layout primitive that
 * is allowed to read app context — every other primitive stays
 * pure. The exception exists so consumers don't have to re-wire
 * the sidebar boilerplate on every screen.
 * ──────────────────────────────────────────────────────────── */

const PageShell = ({ children, className }) => {
  const { sidebar } = useContext(AppContext);
  const shellClass = [styles.shell, className || ''].filter(Boolean).join(' ');

  return (
    <div className={sidebar ? '' : 'cx-active'} id="cx-main">
      <div className={shellClass}>{children}</div>
    </div>
  );
};

PageShell.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageShell.defaultProps = {
  className: '',
};

export default PageShell;
